import axios from 'axios';
import { isWindows } from './common/helpers';

const reLogin = () => {
  if (import.meta.env.MODE === 'development' || window.location.hostname === 'localhost') {
    const { pathname, search } = location;
    const url = `/login${pathname}${search}`;
    location.href = url;
  } else {
    location.reload();
  }
};

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      reLogin();
    }
    return Promise.reject(error);
  }
);

if (isWindows(navigator)) {
  window.document.documentElement.classList.add('windows');
}
